import React from 'react';

import AddSocialLinkForm
  from 'components/dashboard/social-content/AddSocialLinkForm';
import SocialLinksList
  from 'components/dashboard/social-content/SocialLinksList';
import SocialNetworkRequestContent
  from 'components/dashboard/social-content/SocialNetworkRequestContent';

import './SocialPageContent.css';


const SocialPageContent = () => {
  return (
    <div className="social-page-content__component">
      <AddSocialLinkForm />
      <SocialLinksList />
      <SocialNetworkRequestContent type="Social Link" />
    </div>
  );
};

export default SocialPageContent;
